// extracted by mini-css-extract-plugin
module.exports = {"button":"Select_button__p9_0w","popover":"Select_popover__UmS_0","selectItem":"Select_selectItem__govqa","label":"Select_label__jrSzg"};